// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-E":"E_vanlife-roadtrips-E__FbXYf"};